import { render, staticRenderFns } from "./term_form.vue?vue&type=template&id=2c111a74&"
import script from "./term_form.vue?vue&type=script&lang=js&"
export * from "./term_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports